// import KMoney from './k/k-money'
import KHr from './k/k-hr'
import KViewOne from './k/k-view-one'
import KViewTwo from './k/k-view-two'
import KPrdItem from './k/k-prd-item'
import AppraiserGood from './jd/appraiser-good'
import AppraiserItem from './jd/appraiser-item'
import JdTabbar from './jd/jd-tabbar'
import KBtnCheckboxGroup from './k/k-btn-checkbox-group'
import KBtnCheckbox from './k/k-btn-checkbox'
import KNavbar from './k/k-navbar'
import KPriceLv from './jd/k-price-lv'
import JdShbar from './jd/jd-shbar'
import KTextArea from './k/k-textarea'
const components = {
  // KMoney
  KHr,
  KViewOne,
  KViewTwo,
  KPrdItem,
  AppraiserItem,
  JdTabbar,
  AppraiserGood,
  KBtnCheckboxGroup,
  KBtnCheckbox,
  KNavbar,
  KPriceLv,
  JdShbar,
  KTextArea
}

export default Vue => {
  function register(compMap) {
    Object.keys(compMap).forEach((c) => {
      //name = c.name || name
      Vue.component(compMap[c].name, compMap[c])
    })
  }
  register(components)
}
